export default function Contracts() {
  return (
    <section className="sales-layout__page">
      <h1>Verträge</h1>
      <p>Wählen Sie einen Untermenüpunkt aus.</p>
    </section>
  );
}
